import type { SilktideConfig } from '@/silktide/types/silktide'

const grantFunctionality = () => {
  window.gtag?.('consent', 'update', {
    functionality_storage: 'granted'
  })

  window.dataLayer?.push({
    event: 'consent_accepted_functionality'
  })
}

const denyFunctionality = () => {
  window.gtag?.('consent', 'update', {
    functionality_storage: 'denied'
  })
}

const grantAds = () => {
  window.gtag?.('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted'
  })

  window.dataLayer?.push({
    event: 'consent_accepted_ads'
  })
}

const denyAds = () => {
  window.gtag?.('consent', 'update', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  })
}

const grantAnalytics = () => {
  window.gtag?.('consent', 'update', {
    analytics_storage: 'granted'
  })

  window.dataLayer?.push({
    event: 'consent_accepted_analytics'
  })
}

const denyAnalytics = () => {
  window.gtag?.('consent', 'update', {
    analytics_storage: 'denied'
  })
}

export const cookieBannerConfig: SilktideConfig = {
  background: {
    showBackground: true
  },
  cookieIcon: {
    position: 'bottomLeft'
  },
  cookieTypes: [
    {
      id: 'necessary',
      name: 'คุกกี้ที่จำเป็น',
      description: '<p>คุกกี้เหล่านี้จำเป็นสำหรับการทำงานกับเว็บไซต์ และไม่สามารถปิดการใช้งานในระบบของเราได้ และโดยปกติแล้ว คุกกี้เหล่านี้จะถูกกำหนดไว้เพื่อตอบสนองต่อการดำเนินการร้องขอบริการของคุณ เช่น การตั้งค่าความเป็นส่วนตัว การเข้าสู่ระบบ หรือการกรอกแบบฟอร์ม คุณสามารถกำหนดให้เบราว์เซอร์ของคุณทำการบล็อก หรือเตือนให้คุณทราบเกี่ยวกับคุกกี้เหล่านี้ แต่นั่นอาจทำให้บางส่วนของไซต์ไม่สามารถทำงานได้</p>',
      required: true,
      defaultValue: true,
      onAccept: () => {
        console.log('Add logic for the required คุกกี้ที่จำเป็น here')
      }
    },
    {
      id: 'performance',
      name: 'คุกกี้ประสิทธิภาพ',
      description: '<p>คุกกี้เหล่านี้ช่วยเราในการนับจำนวนและที่มาของการเข้าชม เพื่อให้เราสามารถวัดและปรับปรุงประสิทธิภาพไซต์ของเราได้ นอกจากนี้ยังช่วยให้เราทราบว่าหน้าใดได้รับความนิยมมากที่สุดและน้อยที่สุด และทราบว่าผู้เยี่ยมชมเข้าดูส่วนใดบ้าง ข้อมูลทั้งหมดที่คุกกี้เหล่านี้จัดเก็บไว้จะถูกรวมไว้ด้วยกัน จึงทำให้ไม่สามารถระบุตัวตนได้ หากคุณไม่อนุญาตให้คุกกี้เหล่านี้ทำงาน เราจะไม่ทราบว่าคุณเข้าชมไซต์ของเราเมื่อใด</p>',
      required: false,
      defaultValue: false,
      onAccept: grantAnalytics,
      onReject: denyAnalytics
    },
    {
      id: 'functional',
      name: 'คุกกี้การใช้งาน',
      description: '<p>คุกกี้เหล่านี้ช่วยในการทำงานของไซต์และการปรับแต่งไซต์ให้เหมาะกับผู้ใช้ เช่น วิดีโอและการสนทนาสด คุกกี้เหล่านั้นอาจได้รับการกำหนดโดยเราหรือผู้ให้บริการจากบริษัทอื่นที่เราได้เพิ่มบริการของพวกเขาลงในหน้าเพจ หากคุณไม่อนุญาตให้คุกกี้เหล่านี้ทำงาน ฟังก์ชันบางอย่างของไซต์อาจทำงานไม่ถูกต้อง</p>',
      required: false,
      defaultValue: false,
      onAccept: grantFunctionality,
      onReject: denyFunctionality
    },
    {
      id: 'targeting',
      name: 'คุกกี้กำหนดเป้าหมาย',
      description: '<p>คุกกี้เหล่านี้จะถูกกำหนดผ่านไซต์ของเราโดยพาร์ทเนอร์โฆษณาของเรา โดยบริษัทดังกล่าวอาจใช้คุกกี้เหล่านี้เพื่อสร้างโปรไฟล์เกี่ยวกับความสนใจของคุณ และแสดงโฆษณาที่คุณสนใจบนไซต์อื่นๆ คุกกี้เหล่านี้ทำงานโดยการระบุแต่ละเบราว์เซอร์และอุปกรณ์ของคุณ หากคุณไม่อนุญาตให้คุกกี้เหล่านี้ทำงาน คุณจะไม่เห็นโฆษณาที่คุณเป็นเป้าหมายบนเว็บไซต์ต่างๆ</p>',
      required: false,
      defaultValue: false,
      onAccept: grantAds,
      onReject: denyAds
    }
  ],
  text: {
    banner: {
      description: '<p><b>นโยบายคุ้มครองข้อมูลส่วนบุคคลและการใช้คุกกี้</b><br>เราใช้คุกกี้เพื่อช่วยให้ไซต์ของเราทำงานได้อย่างถูกต้อง และมอบประสบการณ์การใช้งานบนไซต์ของเราได้ดียิ่งขึ้น รวมถึง ทำให้เราสามารถแสดงเนื้อหาและโฆษณา กิจกรรมส่งเสริมการขาย และกิจกรรมทางสังคมต่าง ๆ (social activity) ที่ตรงกับความสนใจของท่าน ท่านสามารถศึกษาเพิ่มเติมเกี่ยวกับการใช้งานคุกกี้ การดูแลรักษาข้อมูลส่วนบุคคล และสิทธิต่าง ๆ ของท่าน ได้ที่<a href="https://corporate.lotuss.com/privacy/" target="_blank">นโยบายคุ้มครองข้อมูลส่วนบุคคลและการใช้คุกกี้</a></p>',
      acceptAllButtonText: 'ยอมรับคุกกี้ทั้งหมด',
      acceptAllButtonAccessibleLabel: 'Accept all cookies',
      rejectNonEssentialButtonText: 'ปฏิเสธสิ่งที่ไม่จำเป็น',
      rejectNonEssentialButtonAccessibleLabel: 'Reject non-essential',
      preferencesButtonText: 'การตั้งค่าคุกกี้',
      preferencesButtonAccessibleLabel: 'Toggle preferences'
    },
    preferences: {
      title: 'ศูนย์การตั้งค่าความเป็นส่วนตัว',
      description: '<p>เมื่อคุณเข้าชมเว็บไซต์ใดก็ตาม ไซต์นั้นอาจจัดเก็บหรือดึงข้อมูลจากเบราว์เซอร์ของคุณ ส่วนใหญ่แล้วอยู่ในรูปแบบของคุกกี้ ข้อมูลนี้อาจเกี่ยวกับคุณ การตั้งค่าของคุณ อุปกรณ์ของคุณ หรือเพื่อช่วยให้ไซต์ทำงานอย่างที่คุณต้องการ ซึ่งมักเป็นข้อมูลที่ไม่สามารถระบุตัวตนของคุณได้โดยตรง แต่ช่วยให้คุณใช้งานเว็บตามความต้องการส่วนบุคคลได้มากยิ่งขึ้น คุณสามารถปฏิเสธไม่ให้คุกกี้บางประเภททำงานได้ คลิกที่หัวข้อประเภทอื่นๆ เพื่อดูข้อมูลเพิ่มเติมและเปลี่ยนการตั้งค่าเริ่มต้นของเรา อย่างไรก็ตาม คุณควรทราบว่าการบล็อกคุกกี้บางประเภทอาจส่งผลต่อการใช้งานไซต์และบริการที่เรามีให้ใช้งาน<br><a href="https://corporate.lotuss.com/privacy/" target="_blank">ข้อมูลเพิ่มเติม</a><br></p>'
    }
  },
  position: {
    banner: 'bottomCenter'
  }
}
